import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseAdvertisments } from "./UseAdvertisments";

export default function TariffsAutoComplete(props) {
  const { getAdvertismentByID } = UseAdvertisments();
  const [tariffsRes, setTariffRes] = useState([]);
  const [selectedTariff, setSelectedTariff] = useState();

  useEffect(() => {
    if (props.advertismentID) {
      getAdvertismentByID(props.advertismentID, (resault) => {
        setTariffRes(resault.tariffs);
      });
    }
  }, [props.advertismentID]);

  useEffect(() => {
    if (!props.selectedTariffID) {
      setSelectedTariff();
    }
  }, [props.selectedTariffID]);

  useEffect(() => {
    if (tariffsRes && props.selectedTariffID) {
      setSelectedTariff(tariffsRes.find((m) => m.id == props.selectedTariffID));
    }
  }, [tariffsRes, props.selectedTariffID]);

  useEffect(() => {
    if (selectedTariff && !props.state.id) {
      props.setState({
        ...props.state,
        tariffID: selectedTariff.id,
        time: selectedTariff.title,
        cost: selectedTariff.cost,
      });
    } else if (selectedTariff && props.state.id) {
      props.setState({
        ...props.state,
        tariffID: selectedTariff.id,
      });
    }
  }, [selectedTariff]);

  return tariffsRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.contract && "70%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        value={selectedTariff ? selectedTariff : ""}
        options={tariffsRes ? tariffsRes : []}
        getOptionLabel={(items) => (items.title ? items.title : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField error={props.errorState} {...params} label="تعرفه" />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.title ? option.title : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedTariff(newValue);
          } else {
            setSelectedTariff();
            props.setState({
              ...props.state,
              tariffID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAdvertismentByID(props.advertismentID, (resault) => {
            setTariffRes(resault.tariffs);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/advertisments" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
